import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ShieldCaution18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M9.75012 5V10H8.25012V5H9.75012Z' fill='currentColor' />
    <path
      d='M10.0001 12C10.0001 12.5523 9.55241 13 9.00012 13C8.44784 13 8.00012 12.5523 8.00012 12C8.00012 11.4477 8.44784 11 9.00012 11C9.55241 11 10.0001 11.4477 10.0001 12Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.75024 0.29285C8.91193 0.235717 9.08831 0.235717 9.25 0.29285L14.9078 2.29209C15.3675 2.45195 15.7501 2.9218 15.7501 3.42V11.6635C15.7289 12.8459 15.065 13.9801 14.0452 14.5779L9.41241 17.6265C9.16221 17.7912 8.83804 17.7912 8.58783 17.6265L3.95506 14.5779C2.93524 13.9801 2.27149 12.8459 2.25024 11.6635L2.25 11.65L2.25012 3.42C2.25012 2.92182 2.63276 2.45197 3.09236 2.2921L8.75024 0.29285ZM3.75012 3.65057V11.6427C3.76547 12.3684 4.17385 12.9262 4.76241 13.3135L9.00012 16.1022L13.2378 13.3135C13.822 12.9291 14.2348 12.3673 14.2501 11.6427V3.65057L9.00012 1.79545L3.75012 3.65057Z'
      fill='currentColor'
    />
  </Svg>
);

ShieldCaution18.displayName = 'ShieldCaution18';
export default ShieldCaution18;
